const options = {
  5: "bg-zinc-100/5",
  10: "bg-zinc-100/10",
  25: "bg-zinc-100/25",
  50: "bg-zinc-100/50",
  75: "bg-zinc-100/75",
  90: "bg-zinc-100/90",
  100: "bg-zinc-100",
};

const from = {
  5: "from-zinc-100/5",
  10: "from-zinc-100/10",
  25: "from-zinc-100/25",
  50: "from-zinc-100/50",
  75: "from-zinc-100/75",
  90: "from-zinc-100/90",
  100: "from-zinc-100",
};

export default function getBackgroundZinc100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
